import { render, staticRenderFns } from "./infoList.vue?vue&type=template&id=f4adfdb2&scoped=true"
import script from "./infoList.vue?vue&type=script&lang=js"
export * from "./infoList.vue?vue&type=script&lang=js"
import style0 from "./infoList.vue?vue&type=style&index=0&id=f4adfdb2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4adfdb2",
  null
  
)

export default component.exports